import * as Sentry from '@sentry/react';

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !isLocalhost,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION,

  sendDefaultPii: true,

  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    })
  ],

  // Tracing
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0,
  tracePropagationTargets: [/^https:\/\/yqmlqctpakqxtwzrdofl\.supabase\.co/],

  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Logging
  enableLogs: true,

  // Profiling
  profilesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,

  // Drop chunk-load errors — these are handled by lazyWithRetry (auto-reload)
  beforeSend(event) {
    const message = event.exception?.values?.[0]?.value || '';
    if (message.includes('Failed to fetch dynamically imported module') ||
        message.includes('Importing a module script failed')) {
      return null;
    }
    return event;
  }
});
